exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.s-canvas[data-v-ceb5d1aa] {\n  height: 47px;\n}\n.s-canvas canvas[data-v-ceb5d1aa] {\n  margin-top: 1px;\n  margin-left: 8px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_supplier/src/components/sidentify.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB","file":"sidentify.vue","sourcesContent":["\n.s-canvas[data-v-ceb5d1aa] {\n  height: 47px;\n}\n.s-canvas canvas[data-v-ceb5d1aa] {\n  margin-top: 1px;\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ceb5d1aa","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sidentify.vue
// module id = h2WI
// module chunks = 0